// this is reusable facility select option
//needs react form hook with controller and others to pass in by props
//by sending desirable props we can show only parents ,childrens ...

import React, { useEffect, useState } from "react";
import { FormHelperText, TextField } from "@mui/material";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { Checkbox } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { createFilterOptions } from "@mui/material";
import { useSelector } from "react-redux";
import { storeStateType, useAppDispatch } from "../../../redux/store";
import { IFacilityOption } from "../Types/calendarTypes";
import { scheduleFacilityType } from "../../../redux/reducers/schedule.reducer";
import { loadScheduleFacilities } from "../../../redux/actions/schedule.actions";
import { useCallback } from "react";

type facilityInputChildPropsType = {
  className?: string;
  control: Control<any, any>;
  errors: any;
  deep?: number;
  showParentOnly?: false;
  showChildrenOnly?: true;
  parentId: string;
  variableName: string;
  defaultValue?: string;
  setValue: any;
  label: string;
  isLoadFacilities: boolean;
  shrink?: boolean;
  variant?: "outlined" | "standard";
};

type facilityInputParentPropsType = {
  className?: string;

  control: Control<any, any>;
  errors: any;
  deep?: number;
  showParentOnly?: true;
  showChildrenOnly?: false;
  variableName: string;
  parentId?: string;
  defaultValue?: string;
  setValue: any;
  label: string;
  isLoadFacilities: boolean;
  variant?: "outlined" | "standard";
};

export default function FacilityInputField(
  props: facilityInputChildPropsType | facilityInputParentPropsType
) {
  const {
    className,
    control,
    errors,
    showParentOnly,
    showChildrenOnly,
    parentId,
    defaultValue,
    variableName,
    setValue,
    label,
    isLoadFacilities,
    variant = "standard",
  } = props;
  const dispatch = useAppDispatch();
  const { facilities } = useSelector((state: storeStateType) => state.schedule);
  const [optionsList, setOptionsList] = useState<IFacilityOption[]>([]);
  const [, setReload] = useState<boolean>(false);

  useEffect(() => {
    // dispatch(loadFacitlies());
    if (isLoadFacilities) dispatch(loadScheduleFacilities());
  }, [isLoadFacilities, dispatch]);

  const toOptions = useCallback(
    (
      category: scheduleFacilityType,
      depth: number = 0,
      parentId: string | null = null
    ) => {
      const { id, facility_name, childCategories = [] } = category;
      let children: IFacilityOption[] = [];
      if (!showParentOnly) {
        //get children if show parent false
        children = childCategories?.flatMap((child: scheduleFacilityType) =>
          toOptions(child, depth + 1, id.toString())
        );
      }
      const option = {
        id: id.toString(),
        facility_name,
        depth,
        parentId,
        matchTerms: [facility_name].concat(
          children.map((obj: IFacilityOption) => obj.facility_name)
        ),
      };

      return [option].concat(children);
    },
    [showParentOnly]
  );

  useEffect(() => {
    //show childrens only of particular parent id
    if (showChildrenOnly && facilities && parentId) {
      let selectedFacilities = facilities.filter((facility) => {
        //returning only same parentId childrens
        if (facility.id?.toString() === parentId?.toString()) return facility;
        return null;
      });

      let optionedList = selectedFacilities.flatMap((category: any) => {
        return toOptions(category);
      });
      if (defaultValue) {
        let defaultOption = optionedList.filter((option: IFacilityOption) => {
          if (option.id?.toString() === defaultValue?.toString()) return option;
          return null;
        });
        if (defaultOption.length) {
          // setDefaultValueOption(defaultOption[0]);
          setValue(variableName, defaultOption[0]);
        }
      }

      setOptionsList(
        optionedList.filter((option: IFacilityOption) => {
          if (option.id?.toString() === parentId?.toString()) return false;
          return true;
        })
      );
    }

    //show parents only no looping to children
    else {
      let optionedList = facilities?.flatMap(
        (category: scheduleFacilityType) => {
          return toOptions(category);
        }
      );
      if (defaultValue) {
        let defaultOption = optionedList.filter((option) => {
          if (option.id?.toString() === defaultValue?.toString()) return option;
          return false;
        });
        if (defaultOption.length) {
          setValue(variableName, defaultOption[0]);
          setReload((preState) => !preState);
        }
      }

      setOptionsList(optionedList);
    }
  }, [
    facilities,
    parentId,
    defaultValue,
    setValue,
    variableName,
    showChildrenOnly,
    toOptions,
  ]);

  // function toOptions(category: scheduleFacilityType, depth: number = 0, parentId: string | null = null): IFacilityOption[] {
  //   const { id, facility_name, childCategories = [] } = category;
  //   let children: IFacilityOption[] = [];
  //   if (!showParentOnly) {
  //     //get children if show parent false
  //     children = childCategories?.flatMap((child: scheduleFacilityType) => toOptions(child, depth + 1, id.toString()));
  //   }
  //   const option = {
  //     id: id.toString(),
  //     facility_name,
  //     depth,
  //     parentId,
  //     matchTerms: [facility_name].concat(children.map((obj: IFacilityOption) => obj.facility_name)),
  //   };

  //   return [option].concat(children);
  // }

  return (
    <Controller
      control={control}
      name={variableName}
      defaultValue={null}
      render={({ field: { onChange, value } }) => (
        <>
          <Autocomplete
            sx={{ padding: 0 }}
            onChange={(event, item) => {
              onChange(item);
              //return item
            }}
            value={value}
            options={optionsList}
            //getOptionLabel={(item) => item.facility_name}
            isOptionEqualToValue={(option, value) =>
              option.id?.toString() === value.id?.toString()
            }
            getOptionLabel={(item) =>
              item.facility_name ? item.facility_name : ""
            }
            /*  getOptionSelected={(option:any, value:any) =>
            value === undefined || value === "" || option.id === value.id
          } */

            renderOption={(props, option, { selected, inputValue }) => {
              const matches = match(option.facility_name, inputValue);
              const parts = parse(option.facility_name, matches);
              return (
                <li {...props}>
                  <Checkbox checked={selected} sx={{ ml: 2 * option.depth }} />
                  <div>
                    {parts.map((part: any, index: number) => (
                      <span
                        key={index}
                        style={{
                          fontWeight: part.highlight ? 700 : 400,
                        }}
                      >
                        {part.text}
                      </span>
                    ))}
                  </div>
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant={variant}
                label={label}
                className={className}
              />
            )}
            filterOptions={createFilterOptions({
              // join with some arbitrary separator to prevent matches across adjacent terms
              stringify: (option: any) => option.matchTerms.join("//"),
            })}
          />
          <FormHelperText error={!!errors[variableName]}>
            {errors[variableName] ? errors[variableName].message : ""}
          </FormHelperText>
        </>
      )}
    />
  );
}
